import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { ClientOnly } from '@/components/ClientOnly';

const MobileStickyCTA = lazy(() => import('@/components/MobileStickyCTA'));

/**
 * Pass-through layout for root public routes.
 * Site is English-only at clean root URLs (no /en or /el prefix).
 */
export function LanguageLayout() {
  return (
    <div className="public-site">
      <Outlet />
      {/* Hidden until the visitor scrolls past the hero, so it is left out of
          the prerendered HTML and loads after hydration. */}
      <ClientOnly>
        <Suspense fallback={null}>
          <MobileStickyCTA />
        </Suspense>
      </ClientOnly>
    </div>
  );
}

/**
 * Catches legacy /en/* and /el/* SPA navigations and strips the prefix
 * client-side. (Netlify also 301-redirects these at the edge.)
 */
export function StripLangRedirect() {
  const location = useLocation();
  const cleaned = location.pathname.replace(/^\/(en|el)(?=\/|$)/, '') || '/';
  return <Navigate to={`${cleaned}${location.search}${location.hash}`} replace />;
}
